<div class="m-auto screen-loader">
  <div
    class="center-align"
    *ngIf="screenLoaderData?.icon"
  >
    <div>
      <i class="fa-solid {{ screenLoaderData?.icon }} text-primary"></i>
    </div>
  </div>
  <div
    class="pt-7 center-align"
  >
    <div>
      <h2
        *ngIf="screenLoaderData?.title"
        class="text-secondary m-0 fw-500"
        [innerHTML]="screenLoaderData?.title"
      ></h2>
      <h2
        class="text-secondary text-center mt-0 fw-500"
        *ngIf="screenLoaderData?.sub_title"
      >
        {{ screenLoaderData?.sub_title }}
      </h2>
    </div>
  </div>
  <div
    *ngIf="
      screenLoaderData &&
      screenLoaderData.data &&
      screenLoaderData.data.length > 0
    "
  >
    <div>
      <div class="block-1 pt-7">
        <div
          class="grid-item m-auto"
          *ngFor="let get of screenLoaderData?.data"
        >
          <div class="m-0 f-14 text-secondary">
            <ng-container
              *ngIf="
                (checkTypeOf(get.value) === 'string' ||
                  checkTypeOf(get.value) === 'number') &&
                get.value && get.value != ''
              "
            >
              <label class="fw-700 text-primary mt-0"> {{ get.key }}</label
              ><br />
              <div>
                {{ get.value }}
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                checkTypeOf(get.value) === 'object' && get.value?.length > 0
              "
            >
              <label class="fw-700 text-primary mt-0"> {{ get.key }}</label
              ><br />
              <div class="pt-2" *ngFor="let set of get.value">
                <span class="query-tag">{{ set.keyword }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="pt-7"
  >
    <div class="loading-box">
      <div id="loading"></div>
    </div>
  </div>
</div>
